<template >
  <div class="mainbody">
    <VueUeditorWrap :destroy="true" v-model="remark" :config="editorConfig" />
    <FootLayout v-on:saveEdit="saveEdit" v-on:leftFunction="leftFunction" leftTitle="重置"></FootLayout>
  </div>
</template>
<script>
import { isEmpty } from '@/utils/strUtils'
import { URL_PATH, Editor_Config } from '@/config/config'
import VueUeditorWrap from 'vue-ueditor-wrap'
import FootLayout from '@/components/layout/footLayout'

export default {
  components: {
    FootLayout,
    VueUeditorWrap
  },
  data() {
    return {
      remarkServer: '',
      remark: '',
      editorConfig: Editor_Config
    }
  },
  mounted() {},
  created() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.$api
        .getEmailRemark()
        .then(({ data }) => {
          this.remarkServer = data.Data.value
          this.remark = data.Data.value
        })
        .catch(({ error }) => {})
    },
    leftFunction() {
      if (isEmpty(this.remarkServer)) {
        this.remark = ''
      } else {
        this.remark = this.remarkServer
      }
    },
    // 保存
    saveEdit() {
      this.$api
        .updateEmailRemark({
          token: localStorage.getItem('token'),
          remark: this.remark
        })
        .then(({ data }) => {
          this.$message({
            message: '提交成功',
            type: 'success'
          })
        })
        .catch(({ error }) => {})
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/applyLog/loginSetting.vue